import React from 'react'
import styles from './GlobalFooter.scss'
import cx from 'classnames'

const YEAR = new Date().getFullYear()

export const GlobalFooter = ({className}) => (
  <div className={cx(styles.GlobalFooter, className)}>
    <div className={styles.logo}>
      <a href='/'>
        <img src='/images/revised_layout/logo.png' />
      </a>
      <div className={styles.slogan}>
        Get Inspired, Not Lost.  © {YEAR} Ride with GPS.
        <a href='/terms'>Terms of Service</a>. <a href='/privacy'>Privacy Policy</a>.
      </div>
    </div>
    <div className={styles.nav}>
      <ul>
        <li>
          <a href='/app'>Mobile App</a>
        </li>
        <li>
          <a href='/app/mobile_route_planner'>Mobile Route Planner</a>
        </li>
        <li>
          <a href='/integrations'>Integrations</a>
        </li>
      </ul>
      <ul>
        <li>
          <a href='/organizations'>Organizations</a>
        </li>
        <li>
          <a href='/experiences'>Experiences</a>
        </li>
      </ul>
      <ul>
        <li>
          <a href='/about'>About Us</a>
        </li>
        <li>
          <a href='/careers'>Careers</a>
        </li>
        <li>
          <a href='/contact'>Contact</a>
        </li>
        <li>
          <a href='/help'>Help Center</a>
        </li>
      </ul>
      <ul>
        <li>
          <a href='https://www.facebook.com/ridewithgps'>Facebook</a>
        </li>
        <li>
          <a href='https://www.twitter.com/ridewithgps'>Twitter</a>
        </li>
        <li>
          <a href='https://www.instagram.com/ridewithgps'>Instagram</a>
        </li>
        <li>
          <a href='https://www.youtube.com/ridewithgps'>YouTube</a>
        </li>
      </ul>
    </div>
  </div>
)
